<template>
    <div class="tecnologia">
        <div>
            <mq-layout mq="md+">
                <b-img :src="require('../../assets/solucoesTecnologiaOPENCARD2.jpg')" fluid-grow></b-img>
            </mq-layout>
            <mq-layout :mq="['xs', 'sm']">
                <b-img :src="require('../../assets/solucoesTecnologiaOPENCARD_SMALL.jpg')" fluid-grow></b-img>
            </mq-layout>
        </div>

        <div class="sobreNos">
            <mq-layout :mq="['xs', 'sm']">
                <ArgolasEffect :configArgolas="configArgolas" class="argsup" />
            </mq-layout>
            <b-container class="conteudoHome1">
                <b-row>
                    <b-col cols="12" class="text-center TituloAbout"></b-col>
                    <b-col cols="12" class="text-center TextoAbout">
                        Nossas <strong>Baterias Inteligentes </strong>
                        combinam de forma exclusiva os benefícios do Lítio
                        com o poder e a conectividade que o <strong>BMS HION</strong> proporciona.
                        Isso maximiza o desempenho, a segurança e a longevidade superando drasticamente as
                        baterias tradicionais e as soluções de armazenamento de energia. 
                        A <strong>Hion Tecnologia</strong> desenvolve <strong>Sistemas Inteligentes de Armazenamento de Energia </strong>
                        para ajudar a indústria, o comércio, as residências e o agronegócio a resolver seus gargalos operacionais, 
                        reduzindo custos e desperdícios com a eficiência, segurança e agilidade da <strong>Internet das Coisas </strong>.
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="4">
                        <img
                            src="../../assets/icon_solucoesTecnologia2.jpg"
                            alt="Hion Tecnologia"
                            class="thumbTecnologia1"
                        >
                        <p class="thumbLegenda" id="somosLegenda"><strong> EFICIÊNCIA<br> ENERGÉTICA</strong></p>
                    </b-col>
                    <b-col cols="12" md="4" class="text-center">
                        <img
                            src="../../assets/icon_solucoesTecnologia1.jpg"
                            alt="Hion Tecnologia"
                            class="thumbTecnologia2"
                        >
                        <p class="thumbLegenda" id="valoresLegenda"><strong>REDUZ CUSTOS<br> OPERACIONAIS</strong></p>
                    </b-col>
                    <b-col cols="12" md="4">
                        <img
                            src="../../assets/icon_solucoesTecnologia3.jpg"
                            alt="Hion Tecnologia"
                            class="thumbTecnologia3"
                        >
                        <p class="thumbLegenda" id="missaoLegenda"><strong>RECARGA<br> ULTRA RÁPIDA</strong></p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="4">
                        <LinhaHorizontal class="linhaesq" :configLinhas="configLinhas" />
                    </b-col>
                    <b-col cols="12" md="4"></b-col>
                    <b-col cols="12" md="4">
                        <ArgolasEffect :configArgolas="configArgolas" class="argdir" />
                    </b-col>
                </b-row>
            </b-container>
            <LinhaHorizontal class="linhasup" :configLinhas="configLinhas" />
        </div>

        <div class="LithiumSolucoesTecnologia">
            <div class="backgroundLithiumSolucoesTecnologia">
                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia4">
                    <LinhaHorizontal :configLinhas="configLinhasLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia5">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia6">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia7">
                    <LinhaHorizontal :configLinhas="configLinhasLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia8">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia9">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia10">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia11">
                    <LinhaHorizontalY :configLinhasY="configLinhasLithiumSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLogoLithiumSolucoesTecnologia1">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoLogoLithiumSolucoesTecnologia2">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisLithiumSolucoesTecnologia1">
                    <AneisEffect :configAneis="configAneisLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisLithiumSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisLithiumSolucoesTecnologia3">
                    <AneisEffect :configAneis="configAneisLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisLithiumSolucoesTecnologia4">
                    <AneisEffect :configAneis="configAneisLithiumSolucoesTecnologia" />
                </div>
                <div class="efeitoArgolasLithiumSolucoesTecnologia1">
                    <ArgolasEffect :configArgolas="configArgolasLithiumSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasLithiumSolucoesTecnologia2">
                    <ArgolasEffect :configArgolas="configArgolasLithiumSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasLithiumSolucoesTecnologia3">
                    <ArgolasEffect :configArgolas="configArgolasLithiumSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasLithiumSolucoesTecnologia4">
                    <ArgolasEffect :configArgolas="configArgolasLithiumSolucoesTecnologia"/>
                </div>
            </div>

            <div class="frontendLithiumSolucoesTecnologia">
                
                <div class="tituloLithiumSolucoesTecnologia text-center">Explore os Benefícios do Li-ion</div>
                <div class="textoLithiumSolucoesTecnologia">
                    Comparadas às baterias de chumbo-ácido, as baterias de íons de Lítio oferecem vantagens significativas, 
                    incluindo maior eficiência energética na carga e na descarga, vida útil mais longa, a capacidade de 
                    realizar mais ciclos sem perder a energia e a capacidade de armazenamento original de fábrica. 
                    As <strong>Baterias Inteligentes HION</strong> apresentam um custo muito melhor ao longo da vida útil do produto. 
                    Dispensam qualquer ação de manutenção, tornando-as um investimento valioso e uma solução inteligente a longo prazo.
                </div>
                <div class="iconesBIGLithiumSolucoesTecnologia">
                    <b-container class="containerIconesBIGtecnologia">
                        <b-row>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_solucoesTecnologia5.jpg"
                                    alt="Li-ion Vida Longa"
                                    class="thumbTecnologia2"
                                >
                                <div class="legendaIconesBIGtecnologia text-center">VIDA LONGA</div>
                            </b-col>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_solucoesTecnologia4.jpg"
                                    alt="Li-ion Segurança"
                                    class="thumbTecnologia2"
                                >
                                <div class="legendaIconesBIGtecnologia text-center">SEGURANÇA</div>
                            </b-col>
                            <b-col cols="12" md="4" class="text-center">
                                <img
                                    src="../../assets/icon_solucoesTecnologia6.jpg"
                                    alt="Li-ion Autonomia"
                                    class="thumbTecnologia2"
                                >
                                <div class="legendaIconesBIGtecnologia text-center">AUTONOMIA</div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

                <div class="iconesSMALLLithiumSolucoesTecnologia">
                    <div class="paiIconesSmallTecnologia1">
                        <div class="maiscapacidade" id="capacidade" @click="openCardCapacidade">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> CAPACIDADE</div>
                        </div>
                        <div class="maiscapacidade" id="modular" @click="openCardModular">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> MODULAR</div>
                        </div>
                        <div class="maiscapacidade" id="recarga" @click="openCardRecarga">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> RECARGA</div>
                        </div>
                        <div class="maiscapacidade" id="potencia" @click="openCardPotencia">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> POTÊNCIA</div>
                        </div>
                    </div>

                    <div class="paiIconesSmallTecnologia2">
                        <div class="maiseficiencia" id="eficiencia" @click="openCardEficiencia">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> EFICIÊNCIA</div>
                        </div>
                        <div class="maiseficiencia" id="temperatura" @click="openCardTemperatura">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> TEMPERATURA</div>
                        </div>
                        <div class="maiseficiencia" id="conectividade" @click="openCardConectividade">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> CONECTIVIDADE</div>
                        </div>
                        <div class="maiseficiencia" id="sustentabilidade" @click="openCardSustentabilidade">
                            <i class="fas fa-plus-circle plusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> SUSTENTABILIDADE</div>
                        </div>
                    </div>

                    <div class="paiIconesSmallTecnologia3">
                        <div class="menospeso" id="peso" @click="openCardPeso">
                            <i class="fas fa-minus-circle minusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> PESO</div>
                        </div>
                        <div class="menospeso" id="memoria" @click="openCardMemoria">
                            <i class="fas fa-minus-circle minusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> EFEITO MEMÓRIA</div>
                        </div>
                        <div class="menospeso" id="acido" @click="openCardAcido">
                            <i class="fas fa-minus-circle minusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> ÁCIDO TÓXICO</div>
                        </div>
                        <div class="menospeso" id="manutencoes" @click="openCardManutencoes">
                            <i class="fas fa-minus-circle minusTecnologia"></i>
                            <div class="legendaIconesSMALLtecnologia"> MANUTENÇÕES</div>
                        </div>
                    </div>
                </div>

                <b-collapse class="collapseTecnologia" id="collapsecapacidade" v-model="capacidadeCollapsed">
                    <div class="BordaCardsTecnologia">
                         As Baterias Inteligentes HION possuem<strong> 60% Mais Capacidade </strong>
                         do que as baterias Chumbo-Ácido equivalentes.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsemodular" v-model="modularCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION estão equipadas com a Tecnologia PMM. <strong> Pack Mecânico Modular HION </strong>.
                        Que se adapta aos principais tipos de aplicações. A Tecnologia PMM está disponível em todos os padrões da indústria,
                        do comércio e das residências.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapserecarga" v-model="recargaCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION permitem <strong> Recargas Ultra Rápidas </strong> com <strong>Alta Eficiência Energética</strong>. 
                        Podendo ser completamente carregada em 1-3 horas. As baterias de íons de Líto podem carregar e descarregar profundamente 
                        com altas demandas energéticas, proporcionando máxima versatilidade para todos os tipos de aplicações.  
                        As Baterias Inteligentes HION são 99% eficientes, minimizando as perdas durante o carregamento, além de virem de fábrica com <strong>Proteção Ativa</strong> contra sobrecargas e curto-circuitos.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsepotencia" v-model="potenciaCollapsed">
                    <div class="BordaCardsTecnologia">
                        <strong>Poder</strong> e <strong>Potência</strong> constante. As Baterias Inteligentes HION fornecem toda Potência disponível 
                        durante os processos de descarga e permitem recargas com a máxima Potência Nominal. 
                        A tensão não cai como nas baterias Chumbo-Ácido equivalentes.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapseeficiencia" v-model="eficienciaCollapsed">
                    <div class="BordaCardsTecnologia">
                        A <strong> Eficiência Energética das Baterias Inteligentes HION é Incomparável </strong>.
                        Especialmente em situações de alto estresse. O carregamento rápido minimiza o tempo de inatividade e a 
                        alta taxa de descarga do Li-ion disponibilizam máxima energia tornando-as perfeitas para qualquer tipo de aplicação.
                        As baterias Chumbo-Ácido equivalentes devem ser carregadas em estágios por mais tempo e apresentam desempenho 
                        ineficiente durante períodos de alta descarga, tornando-as menos versáteis que as Baterias Inteligentes HION.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsetemperatura" v-model="temperaturaCollapsed">
                    <div class="BordaCardsTecnologia">
                        Diferentemente das baterias Chumbo-Ácido equivalentes, as flutuações de temperatura e o esgotamento de energia 
                        mal afetam a entrega de energia das Baterias Inteligentes HION.
                        Isso torna as Baterias Inteligentes HION a escolha lógica para aplicações que esgotam as baterias 
                        ou funcionam com condições climáticas extremas.
                        As Baterias Inteligentes HION são 2.5X mais eficientes em baixas temperaturas em relação
                        as baterias Chumbo-Ácido equivalentes. <strong>Segurança Operacional</strong> em temperaturas de até 65°C.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapseconectividade" v-model="conectividadeCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION possuem sofisticado Sistema Elêtrônico de Gerenciamento capaz de manter a bateria 
                        operando nas condições que possam suprir todas as necessidades de qualquer tipo de aplicação, além de proteger as células 
                        e o pack da bateria de serem danificados, o <strong>BMS HION</strong> permite a total <strong>Gestão, Conectividade e Interação</strong>
                        com a bateria em tempo real.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsesustentabilidade" v-model="sustentabilidadeCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION possuem<strong> 10x Mais Vida Útil </strong>
                        do que as baterias Chumbo-Ácido equivalentes. <strong>Ecológica</strong> e com
                        <strong>Menor Custo Operacional</strong> reduzindo seus gastos com energia e sua conta de luz.
                        As Baterias Inteligentes HION são fabricadas com metais leves, facilitando o 
                        processo de reciclagem e tornando a redistribuição e reutilização fácil e econômica.
                        Reduzindo encargos financeiros e operacionais associados com a reciclagem do chumbo ácido.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsepeso" v-model="pesoCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION possuem<strong> 60% Menos Peso </strong>
                        do que as baterias Chumbo-Ácido equivalentes.
                        Reduza as preocupações e os incidentes causados pelo peso da bateria. 
                        Comparado com outras químicas de baterias, as Baterias Inteligentes HION fornecem <strong>Mais Energia</strong>
                        com <strong> Menos da Metade do Peso</strong> e Tamanho. Isso significa mais flexibilidade e agilidade para
                        seu dia a dia.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsememoria" v-model="memoriaCollapsed">
                    <div class="BordaCardsTecnologia">
                        As Baterias Inteligentes HION não possuem o desagradável<strong> Efeito Memória</strong>, ou seja, 
                        não é preciso carregar a bateria até o total da capacidade e descarregar até o total mínimo, 
                        permitindo que você use 100% da capacidade da bateria ou da maneira que desejar e for mais conveniente. 
                        Sem se preocupar em perder capacidade ou reduzir a vida útil do produto. 
                        As Baterias Inteligentes HION foram projetadas para obter o máximo 
                        desempenho e nossa Tecnologia está na vanguarda do mercado de Armazenamento de Energia, fornecendo máxima energia 
                        com o mínimo de esforço. Nossas Baterias Inteligentes incorporam segurança e recursos que reduzem o risco de 
                        incêndio e explosão durante todo seu ciclo de vida
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapseacido" v-model="acidoCollapsed">
                    <div class="BordaCardsTecnologia">
                        As baterias Chumbo-Ácido equivalentes exigem a substituição periódica da ácido tóxico interno para evitar danos estruturais.
                        Caso contrário, sua vida útil é reduzida ainda mais.
                        As <strong>Baterias Inteligentes HION não contêm Chumbo ou Ácidos Tóxicos</strong> e não liberam gases explosivos durante o carregamento. 
                        Diga adeus aos vapores nocivos com um sistema limpo e construído para um ambiente de trabalho moderno e eficiente.
                    </div>
                </b-collapse>
                <b-collapse class="collapseTecnologia" id="collapsemanutencoes" v-model="manutencoesCollapsed">
                    <div class="BordaCardsTecnologia">
                        <strong>Instale, Utilize e Carregue</strong>. Baterias Inteligentes HION dispensam processos de manutenção. Uma única compra garante longevidade.
                        Simplifique suas operações sem precisar gerenciar os cronogramas de manutenção de troca de ácido de suas baterias. 
                        Isso <strong> Economiza Tempo e Dinheiro</strong>, permitindo que você faça suas atividades essenciais em vez de manter 
                        os cronogramas de manutenção da bateria.
                    </div>
                </b-collapse>

            </div>
            
        </div>

        <div class="PortifolioSolucoesTecnologia">
            <div class="backgroundPortifolioSolucoesTecnologia">
                <div class="efeitoLogoPortifolioSolucoesTecnologia1">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLogoPortifolioSolucoesTecnologia2">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLogoContatoHome1">
                    <HionEffect class="HionEffectHomeContato1" :configHionEffect="configHionEffectPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLogoContatoHome2">                 
                    <HionEffect class="HionEffectHomeContato2" :configHionEffect="configHionEffectPortifolioSolucoesTecnologia" />
                </div>

                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia4">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia5">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia6">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia7">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia8">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia9">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia10">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia11">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia12">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia13">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia7">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia8">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia9">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia10">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia11">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioSolucoesTecnologiaY" />
                </div>

                <div class="efeitoAneisPortifolioSolucoesTecnologia1">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia3">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia4">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia5">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia6">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia7">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia8">
                    <AneisEffect :configAneis="configAneisPortifolioSolucoesTecnologia" />
                </div>

                 <div class="efeitoArgolasPortifolioSolucoesTecnologia1">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia2">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia3">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia4">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia5">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia6">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia7">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia8">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioSolucoesTecnologia"/>
                </div>

            </div>

            <div class="frontendPortifolioSolucoesTecnologia">
                
                <div class="tituloPortifolioSolucoesTecnologia">APLICAÇÕES</div>

                <!-- Portfolio Gallery Grid -->
                <div class="rowTecnologia">
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiEmp">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_empilhadeiras.jpg" alt="Empilhadeiras" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Empilhadeiras</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Empilhadeiras</div>
                            <p>Empilhadeiras, Paleteiras e Rebocadores Elétricos.
                               <em>...S.</em>
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiSto">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_energystorage.jpg" alt="Energy Storage" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Energy Storage</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Energy Storage</div>
                            <p>Gestão de Potência, Peak-Shaving, Power Shift e UPS.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiMob">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_eletromobilidade.jpg" alt="Eletromobilidade" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Eletromobilidade</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Eletromobilidade</div>
                            <p>Veículos Elétricos, Compartilhados ou Autônomos.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiSma">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_smarthome.jpg" alt="Smart Homes" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Smart Homes</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Smart Homes</div>
                            <p>Cidades, Comércios e Residências Inteligentes.
                                <em>.ss.</em>
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiRen">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_renovavel.jpg" alt="Energia Renovável" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Energia Renovável</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Energia Renovável</div>
                            <p>Microgeração Distribuída On-grid ou Off-grid.
                               <em>a...gua.</em>
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiMar">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_maritima.jpg" alt="Marítima" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Marítima</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Marítima</div>
                            <p>Mobilidade Limpa, Potente e Moderna sobre a água.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiInd">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_industria.jpg" alt="Industria 4.0" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Industria 4.0</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Industria 4.0</div>
                            <p>Automação Industrial, Gestão e Conectividade.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiAgro">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_Agro.jpg" alt="Agro 4.0" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Agro 4.0</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Agro 4.0</div>
                            <p>Gestão de Veículos e Tecnologia Agríciola.
                               <em>ad....</em>
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiMil">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_militar.jpg" alt="Militar" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Militar</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Militar</div>
                            <p>Tecnologia ao Serviço da Defesa Nacional.
                               <em>BaixoAlcance</em>
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiDro">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_drone.jpg" alt="Drones" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Drones</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Drones</div>
                            <p>Drones de Rotor ou Asa Fixa de Longo ou Baixo Alcance.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiTel">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_telecomunicacoes.jpg" alt="Telecomunicações" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Telecomunicações</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Telecomunicações</div>
                            <p>Servidores, No-breaks, Antenas de Celular, Internet e Radiofrequência.
                            </p>
                        </div>
                    </div>
                    <div class="columnTecnologia">
                        <div class="contentTecnologia" @click="vaiHos">
                            <div class="imagemPortifolioSolucoesTecnologia">
                                <img src="../../assets/portifolio_hospitalar.jpg" alt="Hospitalar" 
                                    class="fotoPortifolioSolucoesTecnologia" style="width:100%">
                                    <div class="overlayLabel">
                                        <div class="textPortifolioSolucoesTecnologia">Hospitalar</div>
                                    </div>
                            </div>
                            <div class="labelPortifolioSolucoesTecnologia">Hospitalar</div>
                            <p>Diagnósticos, Ressonância, Ultrassom, UTI, Incubadoras, etc.
                                <em>..quência.</em>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import HionEffect from '../efeitos/hion_globo'
import LinhaHorizontal from '../efeitos/LinhaHorizontal'
import LinhaHorizontalY from '../efeitos/LinhaHorizontalY'
import ArgolasEffect from '../efeitos/Argolas'
import AneisEffect from '../efeitos/Aneis'
import VueScrollTo from 'vue-scrollto'

export default {
    name: 'Tecnologia',
    components: { HionEffect, LinhaHorizontal, ArgolasEffect, AneisEffect, LinhaHorizontalY, VueScrollTo  },
    data() {
        return {
            configLinhas: {
                backgroundLinhas: "eee",
                CorLinhas: "#008fac"
            },
            configArgolas: {
                backgroundArgolas: "#eee",
                CorArgola: "#008fac"
            },
            configLinhasLithiumSolucoesTecnologia: {
                backgroundLinhas: "#2e2d2c",
                CorLinhas: "#008fac"
            },
            configLinhasLithiumSolucoesTecnologiaY: {
                backgroundLinhasY: "#2e2d2c",
                CorLinhasY: "#008fac"
            },
            configLinhasPortifolioSolucoesTecnologia: {
                backgroundLinhas: "#eee",
                CorLinhas: "#008fac"
            },
            configLinhasPortifolioSolucoesTecnologiaY: {
                backgroundLinhasY: "#eee",
                CorLinhasY: "#008fac"
            },
            configHionEffectLithiumSolucoesTecnologia: {
                backgroundHionEffect: "#2e2d2c",
                CorHionEffect:"#008fac",
            },
            configHionEffectPortifolioSolucoesTecnologia: {
                backgroundHionEffect: "#eee",
                CorHionEffect:"#008fac",
            },
            configAneisLithiumSolucoesTecnologia: {
                backgroundAneis: "#2e2d2c",
                CorAneis: "#008fac",
            },
            configAneisPortifolioSolucoesTecnologia: {
                backgroundAneis: "#eee",
                CorAneis: "#008fac",
            },
            configArgolasLithiumSolucoesTecnologia: {
                backgroundArgolas: "#2e2d2c",
                CorArgola: "#008fac",
            },
            configArgolasPortifolioSolucoesTecnologia: {
                backgroundArgolas: "#eee",
                CorArgola: "#008fac",
            },
            capacidadeCollapsed: false,
            modularCollapsed: false,
            recargaCollapsed: false,
            potenciaCollapsed: false,
            eficienciaCollapsed: false,
            temperaturaCollapsed: false,
            conectividadeCollapsed: false,
            sustentabilidadeCollapsed: false,
            pesoCollapsed: false,
            memoriaCollapsed: false,
            acidoCollapsed: false,
            manutencoesCollapsed: false,
        }
    },
    methods: {
        fechaTodosCards() {
            this.capacidadeCollapsed = false;
            this.modularCollapsed = false;
            this.recargaCollapsed = false;
            this.potenciaCollapsed = false;
            this.eficienciaCollapsed = false;
            this.temperaturaCollapsed = false;
            this.conectividadeCollapsed = false;
            this.sustentabilidadeCollapsed = false;
            this.pesoCollapsed = false;
            this.memoriaCollapsed = false;
            this.acidoCollapsed = false;
            this.manutencoesCollapsed = false;
        },
        openCardCapacidade() {
            if(!this.capacidadeCollapsed) {
                this.fechaTodosCards();
                this.capacidadeCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardModular() {
            if(!this.modularCollapsed) {
                this.fechaTodosCards();
                this.modularCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardRecarga() {
            if(!this.recargaCollapsed) {
                this.fechaTodosCards();
                this.recargaCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardPotencia() {
            if(!this.potenciaCollapsed) {
                this.fechaTodosCards();
                this.potenciaCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardEficiencia() {
            if(!this.eficienciaCollapsed) {
                this.fechaTodosCards();
                this.eficienciaCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardTemperatura() {
            if(!this.temperaturaCollapsed) {
                this.fechaTodosCards();
                this.temperaturaCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardConectividade() {
            if(!this.conectividadeCollapsed) {
                this.fechaTodosCards();
                this.conectividadeCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardSustentabilidade() {
            if(!this.sustentabilidadeCollapsed) {
                this.fechaTodosCards();
                this.sustentabilidadeCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardPeso() {
            if(!this.pesoCollapsed) {
                this.fechaTodosCards();
                this.pesoCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardMemoria() {
            if(!this.memoriaCollapsed) {
                this.fechaTodosCards();
                this.memoriaCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardAcido() {
            if(!this.acidoCollapsed) {
                this.fechaTodosCards();
                this.acidoCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        openCardManutencoes() {
            if(!this.manutencoesCollapsed) {
                this.fechaTodosCards();
                this.manutencoesCollapsed = true;
                if ((this.$mq === 'sm') || (this.$mq === 'xs')) {
                    setTimeout(function(){
                        VueScrollTo.scrollTo('#manutencoes')
                    }, 500);
                }
            }else this.fechaTodosCards();
        },
        vaiEmp() {
            this.$router.push({
                name: 'Empilhadeiras'
            })
        },
        vaiSto() {
            this.$router.push({
                name: 'EnergyStorage'
            })
        },
        vaiMob() {
            this.$router.push({
                name: 'Mobilidade'
            })
        },
        vaiSma() {
            this.$router.push({
                name: 'Smart'
            })
        },
        vaiRen() {
            this.$router.push({
                name: 'Renovavel'
            })
        },
        vaiMar() {
            this.$router.push({
                name: 'Maritima'
            })
        },
        vaiInd() {
            this.$router.push({
                name: 'Industria'
            })
        },
        vaiAgro() {
            this.$router.push({
                name: 'Agro'
            })
        },
        vaiMil() {
            this.$router.push({
                name: 'Militar'
            })
        },
        vaiDro() {
            this.$router.push({
                name: 'Drones'
            })
        },
        vaiTel() {
            this.$router.push({
                name: 'Telecomunicacoes'
            })
        },
        vaiHos() {
            this.$router.push({
                name: 'Hospitalar'
            })
        },
    }
}
</script>

<style>
.tecnologia {
    position: relative;
    background:#eee;
    color:white;
    height: 100%;
    width: 100%;
    min-height: 500px;
}

/* CSS do CARD SOLUCOES E TECNOLOGIA */
.thumbTecnologia1 {
    position:relative;
    width: 150px;
    height: 150px;
    left: 58%;
    border-radius: 50%;
}
.thumbTecnologia2 {
    position:relative;
    width: 150px;
    height: 150px;
    margin:auto;
    border-radius: 50%;
}
.thumbTecnologia3  {
    position:relative;
    width: 150px;
    height: 150px;  
    border-radius: 50%;
}

/* inicio do CSS de LITHIUM  */
.LithiumSolucoesTecnologia {
    position: relative;
    height: 940px;
    width: 100%;
    background: #2e2d2c;
    overflow: hidden;
}
/*BACKGROUND*/
.backgroundLithiumSolucoesTecnologia {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
}
.efeitoLogoLithiumSolucoesTecnologia1 {
    position: absolute;
    top: calc(100% - 170px);
    left: calc(100% - 170px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.HionEffectLithiumSolucoesTecnologia1 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.6;
    transform: rotate(43deg);
}
.efeitoLogoLithiumSolucoesTecnologia2 {
    position: absolute;
    top:calc(100% - 195px);
    left: calc(100% - 195px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.HionEffectLithiumSolucoesTecnologia2 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.15;
    transform: rotate(22deg);
}
.efeitoArgolasLithiumSolucoesTecnologia1 {
    position: absolute;
    top:350px;
    left: 100px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasLithiumSolucoesTecnologia2 {
    position: absolute;
    top:350px;
    left: calc(100% - 40px);
    width: 30px;
    height: 60px;
}
.efeitoArgolasLithiumSolucoesTecnologia3 {
    position: absolute;
    top:calc(60% + 300px);
    left: 80px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasLithiumSolucoesTecnologia4 {
    position: absolute;
    top:calc(40% + 310px);
    left: calc(100% - 40px);
    width: 30px;
    height: 60px;
}
.efeitoLinhaLithiumSolucoesTecnologia1 {
    position: absolute;
    top:10px;
    left: -150px;
    width: 240px;
    height: 55px;
    transform: rotate(180deg);
}
.efeitoLinhaLithiumSolucoesTecnologia2 {
    position: absolute;
    top:158px;
    left: -65px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia3 {
    position: absolute;
    top:250px;
    left: -120px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia4 {
    position: absolute;
    top:10px;
    left: calc(100% - 250px);
    width: 240px;
    height: 55px;
    transform: rotate(-180deg);
}
.efeitoLinhaLithiumSolucoesTecnologia5 {
    position: absolute;
    top:158px;
    left: calc(100% - 175px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia6 {
    position: absolute;
    top:250px;
    left: calc(100% - 220px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia7 {
    position: absolute;
    top:calc(60% + 10px);
    left: -150px;
    width: 240px;
    height: 55px;
    transform: rotate(180deg);
}
.efeitoLinhaLithiumSolucoesTecnologia8 {
    position: absolute;
    top:calc(60% + 158px);
    left: -65px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia9 {
    position: absolute;
    top:calc(60% + 250px);
    left: -120px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia10 {
    position: absolute;
    top:calc(40% + 158px);
    left: calc(100% - 175px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaLithiumSolucoesTecnologia11 {
    position: absolute;
    top:calc(40% + 250px);
    left: calc(100% - 220px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoAneisLithiumSolucoesTecnologia1 {
    position: absolute;
    top:150px;
    left: 125px;
    width: 33.33px;
    height: 100px;
}
.efeitoAneisLithiumSolucoesTecnologia2 {
    position: absolute;
    top:50px;
    left: calc(100% - 125px);
    width: 33.33px;
    height: 100px;
}
.efeitoAneisLithiumSolucoesTecnologia3 {
    position: absolute;
    top:50%;
    left: 80px;
    width: 33.33px;
    height: 100px;
}
.efeitoAneisLithiumSolucoesTecnologia4 {
    position: absolute;
    top:calc(40% + 50px);
    left: calc(100% - 125px);
    width: 33.33px;
    height: 100px;
}

/*FRONTEND*/
.frontendLithiumSolucoesTecnologia {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 4;
}
.tituloLithiumSolucoesTecnologia {
    display: inline-block;
    width:100%;
    margin:auto;
    padding: 100px 200px 10px 200px;
    font-size: 3em;
    font-weight: bold;
    color: #008fac;
    font-family: 'Roboto';
    text-shadow: 2px 2px #000;
}
.textoLithiumSolucoesTecnologia {
    margin: auto;
    text-align: center;
    display: inline-block;
    padding: 50px 200px 10px 200px;
    font-size: 1.1em;
    color: #eee;
    font-family: 'Play';
    text-shadow: 1px 1px #000;
}
.iconesBIGLithiumSolucoesTecnologia {
    display: inline-block;
    width:100%;
    height: 280px;
    margin:auto;
    padding: 50px 150px 10px 150px;
    color: #eee;
    overflow: hidden;
}
.containerIconesBIGtecnologia {
    width: 100%;
    height: 100%;
}
.legendaIconesBIGtecnologia {
    font-size: 1.3em;
    color: #ffd618;
    font-family: 'Play';
    text-shadow: 2px 2px #000;
}

.iconesSMALLLithiumSolucoesTecnologia {
    width:100%;
    margin:auto;
    align-content: center;
    text-align: center;
}
.paiIconesSmallTecnologia1,
.paiIconesSmallTecnologia2,
.paiIconesSmallTecnologia3 {
    display:inline-block;
    margin:auto;
    align-content: center;
    text-align: center;
    width:100%;
    padding-bottom: 10px;
}
.maiscapacidade {
    display:inline;
    margin:auto;
    text-shadow: 1px 1px #000;
}
.maiseficiencia {
    display:inline;
    margin:auto;
    text-shadow: 1px 1px #000;
}
.menospeso {
    display:inline;
    margin:auto;
    text-shadow: 1px 1px #000;
}
#capacidade {
    padding-left: 35px;
    padding-right: 80px;
}
#modular {
    padding-left: 8px;
    padding-right: 100px;
}
#recarga {
    padding-left: 37px;
    padding-right: 110px;
}
#potencia {
    padding-left: 40px;
    padding-right: 110px;
}
#eficiencia {
    padding-left: 50px;
    padding-right: 50px;
}
#temperatura {
    padding-left: 50px;
    padding-right: 50px;
}
#conectividade {
    padding-left: 50px;
    padding-right: 50px;
}
#sustentabilidade {
    padding-left: 50px;
    padding-right: 50px;
}
#peso {
    padding-left: 13px;
    padding-right: 87px;
}
#memoria {
    padding-left: 55px;
    padding-right: 45px;
}
#acido {
    padding-left: 39px;
    padding-right:61px;
}
#manutencoes {
    padding-left: 55px;
    padding-right: 45px;
}
.plusTecnologia {
    color: #00ac5c;
    font-size: 1.5em;
}
.minusTecnologia {
    color: #ffd618;
    font-size: 1.5em;
}
.legendaIconesSMALLtecnologia {
    display: inline;
    font-size: 1em;
    color: #eee;
    font-family: 'Play';
}
.maiscapacidade:hover .plusTecnologia,
.maiseficiencia:hover .plusTecnologia,
.menospeso:hover .plusTecnologia {
    color: #eee;
    cursor: pointer;
}
.maiscapacidade:hover .minusTecnologia,
.maiseficiencia:hover .minusTecnologia,
.menospeso:hover .minusTecnologia {
    color: #ac0b00;
    cursor: pointer;
}
.maiscapacidade:hover .legendaIconesSMALLtecnologia,
.maiseficiencia:hover .legendaIconesSMALLtecnologia,
.menospeso:hover .legendaIconesSMALLtecnologia {
    color: #008fac;
    cursor: pointer;
}
.BordaCardsTecnologia {
    position:relative;
    width: 80%;
    margin:auto;
    height: 100%;
    border: solid 2px #008fac;
    border-radius: 15px;
    font-size: 0.9em;
    color: #eee;
    font-family: 'Raleway';
    text-align: center;
    padding: 0px 20px 0px 20px;
    text-shadow: 1px 1px #000;
}

/* inicio do CSS de Portifolio  ****************************************************/
.PortifolioSolucoesTecnologia {
    position: relative;
    height: 3900px;
    width: 100%;
    background: #eee;
    overflow: hidden;
    box-sizing: border-box;
    font-family: 'Raleway';
    color: #2e2d2c;
}
/*BACKGROUND PORTIFOLIO*****************************/
.backgroundPortifolioSolucoesTecnologia {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 3;
}
.efeitoLogoPortifolioSolucoesTecnologia1 {
    position: absolute;
    top: -170px;
    left: calc(100% - 170px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.efeitoLogoPortifolioSolucoesTecnologia2 {
    position: absolute;
    top:-195px;
    left: calc(100% - 195px);
    height: 400px;
    width: 400px;
    overflow: hidden;
}
.efeitoLinhaPortifolioSolucoesTecnologia4 {
    position: absolute;
    top:30%;
    left: calc(100% - 180px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia5 {
    position: absolute;
    top:12%;
    left: calc(100% - 175px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia6 {
    position: absolute;
    top:15%;
    left: calc(100% - 220px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia7 {
    position: absolute;
    top:20px;
    left: 60%;
    width: 240px;
    height: 55px;
    transform: rotate(180deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia8 {
    position: absolute;
    top:40%;
    left: -60px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia9 {
    position: absolute;
    top:90%;
    left: -60px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia10 {
    position: absolute;
    top:65%;
    left: calc(100% - 175px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia11 {
    position: absolute;
    top:25%;
    left: -60px;
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia12 {
    position: absolute;
    top:90%;
    left: calc(100% - 175px);
    width: 240px;
    height: 55px;
    transform: rotate(90deg);
}
.efeitoLinhaPortifolioSolucoesTecnologia13 {
    position: absolute;
    top:calc(100% - 100px);
    left: calc(100% - 280px);
    width: 240px;
    height: 55px;
}

.efeitoAneisPortifolioSolucoesTecnologia1 {
    position: absolute;
    top:450px;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia2 {
    position: absolute;
    top:10px;
    left: 200px;
    width: 33.33px;
    height: 100px;
    transform:rotate(90deg);
}
.efeitoAneisPortifolioSolucoesTecnologia3 {
    position: absolute;
    top:50%;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia4 {
    position: absolute;
    top:80%;
    left: 20px;
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia5 {
    position: absolute;
    top:250px;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia6 {
    position: absolute;
    top:23%;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia7 {
    position: absolute;
    top:55%;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}
.efeitoAneisPortifolioSolucoesTecnologia8 {
    position: absolute;
    top:85%;
    left: calc(100% - 50px);
    width: 33.33px;
    height: 100px;
}

.efeitoArgolasPortifolioSolucoesTecnologia1 {
    position: absolute;
    top:750px;
    left: 50px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia2 {
    position: absolute;
    top:750px;
    left: calc(100% - 50px);
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia3 {
    position: absolute;
    top:55%;
    left: 50px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia4 {
    position: absolute;
    top:50%;
    left: calc(100% - 50px);
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia5 {
    position: absolute;
    top:73%;
    left: 50px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia6 {
    position: absolute;
    top:73%;
    left: calc(100% - 50px);
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia7 {
    position: absolute;
    top:calc(100% - 600px);
    left: 50px;
    width: 30px;
    height: 60px;
}
.efeitoArgolasPortifolioSolucoesTecnologia8 {
    position: absolute;
    top:calc(100% - 200px);
    left: calc(100% - 50px);
    width: 30px;
    height: 60px;
}

/*FRONTEND PORTIFOLIO************************************/
.frontendPortifolioSolucoesTecnologia {
    position: absolute;
    width: 100%;
    z-index: 4;
    padding: 100px 150px 10px 150px;
}
.tituloPortifolioSolucoesTecnologia {
    display: inline-block;
    width:100%;
    text-align: center;
    font-size: 3em;
    font-weight: 1000;
    color: #008fac;
    font-family: 'Play';
    padding-bottom: 50px;
}
.imagemPortifolioSolucoesTecnologia {
  display:block;
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.fotoPortifolioSolucoesTecnologia {
    border-radius: 10px;
}
.overlayLabel {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: rgb(0, 0, 0);
    background: rgba(0, 0, 0, 0.5); /* Black see-through */
    border-radius: 10px;
    opacity:0;
}
.textPortifolioSolucoesTecnologia {
    color: #eee;
    font-size: 2.5em;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    text-shadow: 1px 1px 20px #000,  0px 0px 20px #008fac,  0px 0px 20px #008fac,  0px 0px 20px #008fac,
                 0px 0px 20px #008fac,  0px 0px 20px #008fac,  0px 0px 20px #008fac,  0px 0px 20px #008fac,
                 0px 0px 20px #008fac,  0px 0px 20px #008fac,  0px 0px 20px #008fac,  0px 0px 20px #008fac;
}
.labelPortifolioSolucoesTecnologia {
    font-weight: bold;
    color: #008fac;
    font-family: 'Play';
    font-size: 1.5em;
}
.rowTecnologia {
  margin: 8px -16px;
}
.rowTecnologia,
.rowTecnologia > .columnTecnologia {
  padding: 8px;
}
.columnTecnologia {
  float: left;
  width: 50%;
}
.rowTecnologia:after {
  content: "";
  display: table;
  clear: both;
}
.contentTecnologia {
    background-color: white;
    padding: 1.5%;
    box-shadow: 5px 5px 10px #2e2d2cee;
    border-radius: 10px;
    position: relative;
    max-width:650px;
}
.contentTecnologia:hover {
    transform: scale(1.02);
    transition: .5s ease;
    cursor: pointer;
}
.contentTecnologia:hover .overlayLabel {
    opacity: 1;
}
.contentTecnologia em {
    color: #fff;
}

/* MEDIA QUERY LG ****************************************************************/
@media (min-width: 992px) and (max-width:1199px) { /* LG */

/* CARD SOLUÇÕES E TECNOLOGIA ************************/
.LithiumSolucoesTecnologia {
    height: 1050px;
}
.tituloLithiumSolucoesTecnologia {
    font-size: 2.6em;
}
.thumbTecnologia1 {
    left: 50%;
}

/* CARD LITIO ****************************************/
.BordaCardsTecnologia {
    width: 75%;
}
#capacidade {
    padding-left: 5px;
    padding-right: 30px;
}
#modular {
    padding-left: 0px;
    padding-right: 68px;
}
#recarga {
    padding-left: 7px;
    padding-right: 80px;
}
#potencia {
    padding-left: 10px;
    padding-right: 80px;
}
#eficiencia {
    padding-left: 20px;
    padding-right: 20px;
}
#temperatura {
    padding-left: 20px;
    padding-right: 20px;
}
#conectividade {
    padding-left: 20px;
    padding-right: 20px;
}
#sustentabilidade {
    padding-left: 20px;
    padding-right: 20px;
}
#peso {
    padding-left: 0px;
    padding-right: 70px;
}
#memoria {
    padding-left: 10px;
    padding-right: 23px;
}
#acido {
    padding-left: 0px;
    padding-right:40px;
}
#manutencoes {
    padding-left: 18px;
    padding-right: 29px;
}

/* inicio do CSS de Portifolio  ****************************************************/
.PortifolioSolucoesTecnologia {
    height: 3150px;
}
/*BACKGROUND PORTIFOLIO*****************************/
.efeitoLinhaPortifolioSolucoesTecnologia7 {
    left: 50%;
}
.efeitoLinhaPortifolioSolucoesTecnologia9 {
    top:calc(100% - 400px);
}
.efeitoArgolasPortifolioSolucoesTecnologia1 {
    top:750px;
    left: 20px;
}
.efeitoArgolasPortifolioSolucoesTecnologia2 {
    top:1100px;
}
.efeitoArgolasPortifolioSolucoesTecnologia4 {
    top:60%;
    left: calc(100% - 100px);
}
.efeitoArgolasPortifolioSolucoesTecnologia7 {
    top:calc(100% - 280px);
    left: 80px;
}
.efeitoArgolasPortifolioSolucoesTecnologia8 {
    top:calc(100% - 600px);
}
.efeitoAneisPortifolioSolucoesTecnologia5 {
    top:550px;
}
.efeitoAneisPortifolioSolucoesTecnologia8 {
    top:calc(100% - 500px);
    left: calc(100% - 50px);
}
/*FRONTEND PORTIFOLIO************************************/


}

/* MEDIA QUERY MD *********************************************************/
@media (min-width: 768px) and (max-width:991px) { /* MD */

/* CARD TECNOLOGIA *********************************/
.LithiumSolucoesTecnologia {
    height: 1300px;
}
.tituloLithiumSolucoesTecnologia {
    font-size: 2.5em;
}
.BordaCardsTecnologia {
    width: 70%;
}
/* CSS do CARD SOLUCOES E TECNOLOGIA */
.thumbTecnologia1 {
    left: 30%;
}

/* CARD LITIO **************************************/
#capacidade {
    padding-left: 5px;
    padding-right: 30px;
}
#modular {
    padding-left: 0px;
    padding-right: 68px;
}
#recarga {
    padding-left: 7px;
    padding-right: 80px;
}
#potencia {
    padding-left: 10px;
    padding-right: 80px;
}
#eficiencia {
    padding-left: 20px;
    padding-right: 20px;
}
#temperatura {
    padding-left: 20px;
    padding-right: 20px;
}
#conectividade {
    padding-left: 20px;
    padding-right: 20px;
}
#sustentabilidade {
    padding-left: 20px;
    padding-right: 20px;
}
#peso {
    padding-left: 0px;
    padding-right: 70px;
}
#memoria {
    padding-left: 10px;
    padding-right: 23px;
}
#acido {
    padding-left: 0px;
    padding-right:40px;
}
#manutencoes {
    padding-left: 18px;
    padding-right: 29px;
}
.efeitoLinhaLithiumSolucoesTecnologia7 {
    top:calc(32% + 10px);
}
.efeitoLinhaLithiumSolucoesTecnologia8 {
    top:calc(32% + 158px);
}
.efeitoLinhaLithiumSolucoesTecnologia9 {
    top:calc(32% + 250px);
}
.efeitoArgolasLithiumSolucoesTecnologia3 {
    top:calc(37% + 300px);
    left: 30px;
}
.efeitoAneisLithiumSolucoesTecnologia4 {
    top:calc(35% + 50px);
}
.efeitoArgolasLithiumSolucoesTecnologia4 {
    top:calc(35% + 310px);
}
.efeitoLinhaLithiumSolucoesTecnologia10 {
    top:calc(35% + 158px);
}
.efeitoLinhaLithiumSolucoesTecnologia11 {
    top:calc(35% + 250px);
}

/* inicio do CSS de Portifolio  ****************************************************/
.PortifolioSolucoesTecnologia {
    height: 2800px;
}
/*BACKGROUND PORTIFOLIO*****************************/
.efeitoLinhaPortifolioSolucoesTecnologia7 {
    left: 40%;
}
.efeitoLinhaPortifolioSolucoesTecnologia8 {
    top:65%;
    left: -70px;
}
.efeitoLinhaPortifolioSolucoesTecnologia9 {
    top:calc(100% - 400px);
}
.efeitoArgolasPortifolioSolucoesTecnologia1 {
    top:750px;
    left: 20px;
}
.efeitoArgolasPortifolioSolucoesTecnologia2 {
    top:1400px;
}
.efeitoArgolasPortifolioSolucoesTecnologia4 {
    top:60%;
    left: calc(100% - 80px);
}
.efeitoArgolasPortifolioSolucoesTecnologia7 {
    top:calc(100% - 280px);
    left: 80px;
}
.efeitoArgolasPortifolioSolucoesTecnologia8 {
    top:calc(100% - 600px);
}
.efeitoAneisPortifolioSolucoesTecnologia5 {
    top:550px;
}
.efeitoAneisPortifolioSolucoesTecnologia8 {
    top:calc(100% - 500px);
    left: calc(100% - 50px);
}
/*FRONTEND PORTIFOLIO************************************/
.frontendPortifolioSolucoesTecnologia {
    padding: 100px 100px 10px 100px;
}
}


/* MEDIA QUERY SM *************************************************************/
@media (min-width: 576px) and (max-width:767px) { /* SM */

/* CARD TECNOLOGIA **********************************/
/* CSS do CARD SOLUCOES E TECNOLOGIA */
.thumbTecnologia1 {
    width: 200px;
    height: 200px;
    left: 30%;
}
.thumbTecnologia2 {
    width: 200px;
    height: 200px;
}
.thumbTecnologia3  {
    width: 200px;
    height: 200px;  
    left: 30%;
}
/* CARD LITIO **************************************/
.LithiumSolucoesTecnologia {
    height: 3400px;
}
.tituloLithiumSolucoesTecnologia {
    font-size: 2.2em;
    padding: 100px 100px 50px 100px;
}
.textoLithiumSolucoesTecnologia {
    padding: 50px 100px 10px 100px;
    font-size: 1.3em;
}
.iconesBIGLithiumSolucoesTecnologia {
    height: 800px;
}
.maiscapacidade {
    display:block;
}
.maiseficiencia {
    display:block;
}
.menospeso {
    display:block;
}
.plusTecnologia {
    font-size: 3em;
}
.minusTecnologia {
    font-size: 3em;
}
.legendaIconesSMALLtecnologia {
    display: block;
    font-size: 1.3em;
}
.BordaCardsTecnologia {
    width: 60%;
    font-size: 1.1em;
}
#capacidade {
    padding-left: 0px;
    padding-right: 0px; 
    padding-top: 10px; 
}
#modular {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#recarga {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#potencia {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#eficiencia {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#temperatura {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#conectividade {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#sustentabilidade {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#peso {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#memoria {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#acido {
    padding-left: 0px;
    padding-right:0px;
    padding-top: 10px; 
}
#manutencoes {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}

.efeitoArgolasLithiumSolucoesTecnologia1 {
    top:15%;
    left: 15px;
}
.efeitoArgolasLithiumSolucoesTecnologia2 {
    top:15%;
    left: calc(100% - 55px);
}
.efeitoArgolasLithiumSolucoesTecnologia3 {
    top:75%;
    left: 15px;
}
.efeitoArgolasLithiumSolucoesTecnologia4 {
    top:55%;
    left: calc(100% - 55px);
}

.efeitoLinhaLithiumSolucoesTecnologia1 {
    top:10px;
}
.efeitoLinhaLithiumSolucoesTecnologia2 {
    top:158px;
}
.efeitoLinhaLithiumSolucoesTecnologia3 {
    top:850px;
}
.efeitoLinhaLithiumSolucoesTecnologia6 {
    top:800px;
    left:calc(100% - 170px);
    transform: rotate(270deg);
}
.efeitoLinhaLithiumSolucoesTecnologia7 {
    top:calc(55% + 10px);
}
.efeitoLinhaLithiumSolucoesTecnologia9 {
    top:calc(80% + 250px);
}
.efeitoLinhaLithiumSolucoesTecnologia11 {
    top:calc(70% + 250px);
    left: calc(100% - 170px);
}

.efeitoAneisLithiumSolucoesTecnologia1 {
    top:35%;
    left: 10px;
}
.efeitoAneisLithiumSolucoesTecnologia2 {
    left: calc(100% - 45px);
    top:35%;
}
.efeitoAneisLithiumSolucoesTecnologia3 {
    left: 15px;
}
.efeitoAneisLithiumSolucoesTecnologia4 {
    left: calc(100% - 45px);
    top:65%;
}


/* inicio do CSS de Portifolio  ****************************************************/
.PortifolioSolucoesTecnologia {
    height: 6500px;
}
/*BACKGROUND PORTIFOLIO*****************************/
.efeitoLinhaPortifolioSolucoesTecnologia7 {
    left: 20%;
}
.efeitoLinhaPortifolioSolucoesTecnologia8 {
    top:70%;
    left: -70px;
}
.efeitoLinhaPortifolioSolucoesTecnologia9 {
    top:calc(100% - 400px);
}
.efeitoArgolasPortifolioSolucoesTecnologia1 {
    top:750px;
    left: 20px;
}
.efeitoArgolasPortifolioSolucoesTecnologia2 {
    top:1400px;
}
.efeitoArgolasPortifolioSolucoesTecnologia3 {
    top:2000px;
}
.efeitoArgolasPortifolioSolucoesTecnologia4 {
    top:60%;
    left: calc(100% - 80px);
}
.efeitoArgolasPortifolioSolucoesTecnologia6 {
    top:3800px;
}
.efeitoArgolasPortifolioSolucoesTecnologia7 {
    top:calc(100% - 280px);
    left: 80px;
}
.efeitoArgolasPortifolioSolucoesTecnologia8 {
    top:calc(100% - 300px);
}
.efeitoAneisPortifolioSolucoesTecnologia5 {
    top:400px;
}
.efeitoAneisPortifolioSolucoesTecnologia8 {
    top:calc(100% - 200px);
    left: calc(100% - 50px);
}
/*FRONTEND PORTIFOLIO************************************/
.frontendPortifolioSolucoesTecnologia {
    padding: 100px 100px 10px 100px;
}
.columnTecnologia {
    width: 100%;
}

}

/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */

/* CSS do CARD SOLUCOES E TECNOLOGIA *************/
.thumbTecnologia1 {
    width: 200px;
    height: 200px;
    left: 30%;
}
.thumbTecnologia2 {
    width: 200px;
    height: 200px;
}
.thumbTecnologia3  {
    width: 200px;
    height: 200px;  
    left: 30%;
}
/* CARD LITIO ***********************************/
.LithiumSolucoesTecnologia {
    height: 3400px;
}
.tituloLithiumSolucoesTecnologia {
    font-size: 2.5em;
    padding: 100px 50px 50px 50px;
}
.textoLithiumSolucoesTecnologia {
    padding: 50px 50px 10px 50px;
    font-size: 1.4em;
}
.iconesBIGLithiumSolucoesTecnologia {
    height: 800px;
    padding: 50px 10px 10px 10px;
}
.maiscapacidade {
    display:block;
}
.maiseficiencia {
    display:block;
}
.menospeso {
    display:block;
}
.plusTecnologia {
    font-size: 3em;
}
.minusTecnologia {
    font-size: 3em;
}
.legendaIconesSMALLtecnologia {
    display: block;
    font-size: 1.3em;
}
.BordaCardsTecnologia {
    width: 70%;
    font-size: 1.1em;
}
#capacidade {
    padding-left: 0px;
    padding-right: 0px; 
    padding-top: 10px; 
}
#modular {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#recarga {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#potencia {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#eficiencia {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#temperatura {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#conectividade {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#sustentabilidade {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#peso {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#memoria {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}
#acido {
    padding-left: 0px;
    padding-right:0px;
    padding-top: 10px; 
}
#manutencoes {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px; 
}

.efeitoArgolasLithiumSolucoesTecnologia1 {
    top:15%;
    left: 15px;
}
.efeitoArgolasLithiumSolucoesTecnologia2 {
    top:15%;
    left: calc(100% - 55px);
}
.efeitoArgolasLithiumSolucoesTecnologia3 {
    top:75%;
    left: 15px;
}
.efeitoArgolasLithiumSolucoesTecnologia4 {
    top:55%;
    left: calc(100% - 55px);
}

.efeitoLinhaLithiumSolucoesTecnologia1 {
    top:10px;
}
.efeitoLinhaLithiumSolucoesTecnologia2 {
    top:158px;
    left: -80px;
    transform: rotate(270deg);
}
.efeitoLinhaLithiumSolucoesTecnologia3 {
    top:850px;
}
.efeitoLinhaLithiumSolucoesTecnologia5 {
    left: calc(100% - 150px);
}
.efeitoLinhaLithiumSolucoesTecnologia6 {
    top:900px;
    left:calc(100% - 170px);
    transform: rotate(270deg);
}
.efeitoLinhaLithiumSolucoesTecnologia7 {
    top:calc(55% + 10px);
}
.efeitoLinhaLithiumSolucoesTecnologia9 {
    top:calc(80% + 250px);
}
.efeitoLinhaLithiumSolucoesTecnologia11 {
    top:calc(70% + 250px);
    left: calc(100% - 170px);
}

.efeitoAneisLithiumSolucoesTecnologia1 {
    top:35%;
    left: 10px;
}
.efeitoAneisLithiumSolucoesTecnologia2 {
    left: calc(100% - 45px);
    top:35%;
}
.efeitoAneisLithiumSolucoesTecnologia3 {
    left: 15px;
}
.efeitoAneisLithiumSolucoesTecnologia4 {
    left: calc(100% - 45px);
    top:65%;
}


/* inicio do CSS de Portifolio  ****************************************************/
.PortifolioSolucoesTecnologia {
    height: 5300px;
}
/*BACKGROUND PORTIFOLIO*****************************/
.efeitoLinhaPortifolioSolucoesTecnologia4 {
    left: calc(100% - 150px);
}
.efeitoLinhaPortifolioSolucoesTecnologia5 {
    left: calc(100% - 150px);
}
.efeitoLinhaPortifolioSolucoesTecnologia7 {
    left: 20%;
}
.efeitoLinhaPortifolioSolucoesTecnologia8 {
    top:70%;
    left: -70px;
}
.efeitoLinhaPortifolioSolucoesTecnologia9 {
    top:calc(100% - 400px);
}
.efeitoLinhaPortifolioSolucoesTecnologia10 {
    left: calc(100% - 150px);
}
.efeitoLinhaPortifolioSolucoesTecnologia11 {
    left: -90px;
}
.efeitoArgolasPortifolioSolucoesTecnologia1 {
    top:680px;
    left: 10px;
}
.efeitoArgolasPortifolioSolucoesTecnologia2 {
    top:1400px;
}
.efeitoArgolasPortifolioSolucoesTecnologia3 {
    top:2000px;
    left: 10px;
}
.efeitoArgolasPortifolioSolucoesTecnologia4 {
    top:60%;
    left: calc(100% - 30px);
}
.efeitoArgolasPortifolioSolucoesTecnologia5 {
    top:75%;
    left: 10px;
}
.efeitoArgolasPortifolioSolucoesTecnologia6 {
    top:3800px;
}
.efeitoArgolasPortifolioSolucoesTecnologia7 {
    top:83%;
    left: calc(100% - 30px);
}
.efeitoArgolasPortifolioSolucoesTecnologia8 {
    top:calc(100% - 300px);
}
.efeitoAneisPortifolioSolucoesTecnologia5 {
    top:400px;
}
.efeitoAneisPortifolioSolucoesTecnologia8 {
    top:calc(100% - 200px);
    left: calc(100% - 50px);
}
/*FRONTEND PORTIFOLIO************************************/
.frontendPortifolioSolucoesTecnologia {
    padding: 100px 80px 10px 80px;
}
.columnTecnologia {
    width: 100%;
}
.tituloPortifolioSolucoesTecnologia {
    padding-bottom: 50px;
    padding-top: 100px;
}

}


</style>